import { Directive, HostListener, Input } from '@angular/core';

@Directive({
  selector: '[appScrollTo]'
})
export class ScrollToDirective {

  @Input()
  private readonly appScrollTo: HTMLElement;

  @HostListener('click')
  onClickElement() {
    setTimeout(() => {
      this.appScrollTo.scrollIntoView({block: 'start', behavior: 'smooth'});
    }, 100);
  }
}
